<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ selected }}</span>
		<app-button
			(click)="createBrokerage()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			[testHook]="testHooks.CreateBrokerageButton"
			>Create brokerage</app-button
		>
	</div>
</ng-template>

<ng-template #brokerageTemplate let-item>
	<div class="flex flex-col" [testHook]="testHooks.BrokerageItemDiv">
		<span class="font-bold truncate">{{ item.name | titlecase }}</span>
		<div class="flex truncate">
			<span class="text-sm"
				>{{ item.address?.street }}, {{ item?.address?.city }}</span
			>
		</div>
	</div>
</ng-template>

<ng-template #brokerTemplate let-item>
	<div class="flex text-truncate" [testHook]="testHooks.BrokerItemDiv">
		<atomic-name-badge
			[firstName]="item.firstName"
			[lastName]="item.lastName"
			size="small"
			[testHook]="testHooks.NameBadge"
		></atomic-name-badge>
		<div class="flex flex-col ml-2 truncate">
			<span class="font-bold whitespace-nowrap"
				>{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}</span
			>
			<span class="text-sm whitespace-nowrap">{{
				item.brokerage | capitalize
			}}</span>
		</div>
	</div>
</ng-template>

<div>
	<app-auto-complete
		(onSelect)="onSelect($event)"
		placeholder="Agent or Brokerage"
		[itemGroups]="[
			{ items: [{ value: 'createNew' }], template: createNewTemplate },
			{
				items: (brokerages$ | async),
				template: brokerageTemplate,
				title: 'Brokerages',
				noResultsMessage: 'No brokerages found',
				type: dropdownSelect.SELECTBROKERAGE,
			},
			{
				items: (brokers$ | async),
				template: brokerTemplate,
				title: 'Brokers',
				type: dropdownSelect.SELECTBROKER,
			},
		]"
		[(ngModel)]="selected"
		name="dual-dropdown-1"
		[minSearchTerm]="2"
		(debounce)="search($event)"
		[loading]="loading"
		width="w-full"
		[label]="label"
		[orientation]="orientation"
		[skeletonLoading]="skeletonLoading"
		[testHook]="testHooks.DualDropdown1AutoComplete"
	>
	</app-auto-complete>
</div>
